/**
 * @file 单个全景详情页新增的vue数据store
 */
import * as Types from '../mutation-types';
import fetchData from '../../service';
import {getParamsFromUrl, captureException, getPlatInfo} from '@baidu/map-fe-utils';
const isOutMap = !getPlatInfo().isNative && getParamsFromUrl().source === 'outmap';

const state = () => ({
});

const mutations = {
};

const getters = {
};
const actions = {
    getFeedDetail: ({rootState, commit}, params) => {
        const urlParams = getParamsFromUrl();
        let cuid = decodeURIComponent(urlParams.cuid);
        let city_id = urlParams.c;
        let loc = urlParams.loc; // 安卓没有定位的时候 loc是空字符串
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'getFeedDetail',
            cuid
        };
        if (loc) {
            loc = loc.replace('(', '').replace(')', '');
            if (loc !== '0.000000,0.000000') {
                initParams.loc = loc;
            }
        }
        if (city_id) {
            initParams.city_id = city_id;
        }
        const fetchParam = Object.assign({}, params, initParams);

        const options = {
            noCuid: noCuid,
            need_sign: 1,
            outmap: isOutMap
        };
        return fetchData('getFeedDetail', fetchParam, options).then(res => {
            if (res && res.result.error === 0 && res.content && res.content.length) {
                const data = res.content[0];
                commit(Types.SET_CUR_PANO_INFO, data, {root: true});
            }
            else {
                throw res;
            }
        }).catch(e => {
            console.error(e);
            // 发送监控
            let err = e instanceof Error ? e : JSON.stringify(e);
            const myErrorMessage = {
                netWork: state.baidumapNet,
                message: `getfeed data error:${err}`
            };
            captureException('getFeedError', JSON.stringify(myErrorMessage));
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};